import { createMixpanelProvider } from '../providers/mixpanelProvider.js';
import { captureException } from '@sentry/core';
import { useState, useEffect } from 'react';
import { useAnalyticsStore } from '../analytics.store.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { ensureError } from '@fabric-app/utils/guards';

const useAnalyticsInitializer = () => {
  const { addProvider, identify } = useAnalyticsStore();
  const { data: user } = useQueryUserInfo();
  const [providersInitialized, setProvidersInitialized] = useState(false);
  useEffect(() => {
    const initializeProviders = async () => {
      try {
        const mixpanelProvider = createMixpanelProvider();
        await mixpanelProvider.initialize();
        addProvider(mixpanelProvider);
        setProvidersInitialized(true);
      } catch (error) {
        captureException(ensureError(error));
      }
    };
    initializeProviders();
  }, [
    addProvider
  ]);
  useEffect(() => {
    if (user && providersInitialized) {
      identify({
        id: user.id,
        email: user.email,
        name: user.name,
        avatar_url: user.pictureUrlCdn || void 0,
        groups: user.groups
      });
    }
  }, [
    identify,
    user,
    providersInitialized
  ]);
};

export { useAnalyticsInitializer };
//# sourceMappingURL=useAnalyticsInitializer.js.map
